/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CopilotMetricActivityBase extends models.CopilotActivityCountBase {
    getFixupPrototypeFunction() { return CopilotMetricActivityBase.fixupPrototype; }

    static newInstance(model: Partial<CopilotMetricActivityBase>): CopilotMetricActivityBase {
        let obj = Object.assign(new CopilotMetricActivityBase(), model);
        CopilotMetricActivityBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CopilotMetricActivityBase>): CopilotMetricActivityBase {
        if (!model) return null;
        return CopilotMetricActivityBase.newInstance(<CopilotMetricActivityBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CopilotMetricActivityBase) {
        if (!obj) return;

        models.CopilotMetricActivityBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CopilotMetricActivityBase): boolean {
        if (models.CopilotActivityCountBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, CopilotMetricActivityBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.lines_of_code_added_sum === undefined) {
            this.lines_of_code_added_sum = 0;
        }
        if (this.lines_of_code_deleted_sum === undefined) {
            this.lines_of_code_deleted_sum = 0;
        }
        if (this.lines_of_code_suggested_to_add_sum === undefined) {
            this.lines_of_code_suggested_to_add_sum = 0;
        }
        if (this.lines_of_code_suggested_to_delete_sum === undefined) {
            this.lines_of_code_suggested_to_delete_sum = 0;
        }
        if (this.user_initiated_interaction_count === undefined) {
            this.user_initiated_interaction_count = 0;
        }
    }

    /**
     * Total lines of code added
     */
    lines_of_code_added_sum: number;

    /**
     * Total lines of code deleted
     */
    lines_of_code_deleted_sum: number;

    /**
     * Total lines of code suggested to add
     */
    lines_of_code_suggested_to_add_sum: number;

    /**
     * Total lines of code suggested to delete
     */
    lines_of_code_suggested_to_delete_sum: number;

    /**
     * Number of user initiated interactions
     */
    user_initiated_interaction_count: number;

}
